import { render } from "./BarChart.vue?vue&type=template&id=5d96f77a&lang=pug"
import script from "./BarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./BarChart.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__